module.exports = __webpack_public_path__ + "img/ic-download.0d6144a3.svg";